function toggleAutoshipATCPopup( openStatus )
{
    var popup   = document.querySelector( ".js-autoship-atc-popup" );
    var overlay = document.querySelector( ".js-autoship-atc-popup-overlay" );
    if ( popup )
    {

        if ( openStatus == true )
        {
            popup.classList.add( "autoship-atc-popup--active" );
            if ( overlay )
            {
                overlay.classList.add( "autoship-atc-popup-overlay--active" );
            }
        }
        else if ( openStatus == false )
        {
            popup.classList.remove( "autoship-atc-popup--active" );
            if ( overlay )
            {
                overlay.classList.remove( "autoship-atc-popup-overlay--active" );
            }
        }
        else
        {
            popup.classList.toggle( "autoship-atc-popup--active" );
            if ( overlay )
            {
                overlay.classList.toggle( "autoship-atc-popup-overlay--active" );
            }
        }
    }
}

function initAutoshipATCPopup( )
{
    var popup = document.querySelector( ".js-autoship-atc-popup" );
    if ( popup )
    {
        var close             = popup.querySelectorAll( ".js-autoship-atc-popup-close" );
        var qsMinus           = popup.querySelector( ".js-autoship-atc-popup-minus" );
        var qsPlus            = popup.querySelector( ".js-autoship-atc-popup-plus" );
        var qsQty             = popup.querySelector( ".js-autoship-atc-popup-quantity" );
        var cart              = popup.querySelector( ".js-autoship-atc-popup-cart" );
        var pdpAutoshipQS     = document.querySelector( ".autoship-purchase-controls .pdp-autoship-qty" );
        var shownQty          = 1;
        var quantity          = 1;
        var requestInProgress = false;

        popup.dataset.quantity = 1;

        close.forEach( el => { el.addEventListener( "click", toggleAutoshipATCPopup ) } );

        cart.addEventListener( "click", function( )
        {
            toggleAutoshipATCPopup( false );
            document.body.classList.toggle( "cart-drawer--show" );

        } );

        function updateOtherQS( newQty )
        {
            updateGridSection( );

            if ( pdpAutoshipQS )
            {
                pdpAutoshipQS.dataset.quantity = newQty;
                
                // Update PDP quantity text to keep it in sync
                var pdpQtyText = pdpAutoshipQS.querySelector( ".pdp-autoship-qty-count" );
                if ( pdpQtyText && typeof AutoshipQtyString === "function" )
                {
                    pdpQtyText.textContent = AutoshipQtyString( newQty );
                }
            }

            // Update sticky button quantity text to keep it in sync
            var stickyQtyContainer = document.querySelector( ".sticky-atc-modal .sticky-autoship-qty.pdp-autoship-qty" );
            if ( stickyQtyContainer )
            {
                var stickyQtyText = stickyQtyContainer.querySelector( ".pdp-autoship-qty-count" );
                if ( stickyQtyText && typeof AutoshipQtyString === "function" )
                {
                    stickyQtyText.textContent = AutoshipQtyString( newQty );
                }
            }
        }

        function cartUpdate( newQty )
        {
            var payload = {
                updates: {},
                sections: "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template"
            };
            payload.updates[popup.dataset.lineKey] = newQty;

            fetch(window.Shopify.routes.root + "cart/update.js",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
            .then(function(r){ return r.json(); })
            .then(function(data)
            {
                quantity          = newQty;
                requestInProgress = false;
                var newestRequest = getNewestRequest( "line", popup.dataset.lineKey );
                if ( newestRequest == null || newestRequest.quantity == quantity )
                {
                    if (typeof updateCartDrawer === "function") updateCartDrawer(data);

                    if (quantity === 0)
                    {
                        toggleAutoshipATCPopup( false );
                        popup.dataset.quantity = quantity;
                        quantity = 1;
                        shownQty = 1;
                    }

                    clearFinishedRequests( "line", popup.dataset.lineKey );
                    updateOtherQS( newQty );
                }
                else
                {
                    cartUpdate( newestRequest.quantity );
                }
            })
            .catch(function(err){ console.warn("cart/update error", err); });
        }

        qsMinus.addEventListener( "click", function( )
        {
            if ( shownQty > 0 )
            {
                shownQty --;
                window.autoshipQuantityUpdates.push( { line: popup.dataset.lineKey, quantity: shownQty } );
                qsQty.textContent = shownQty;
                cartUpdate( shownQty );
            }
        } );

        qsPlus.addEventListener( "click", function( )
        {
            shownQty ++;
            window.autoshipQuantityUpdates.push( { line: popup.dataset.lineKey, quantity: shownQty } );
            qsQty.textContent = shownQty;
            cartUpdate( shownQty );
        } );
    }
}

function renderAutoshipATCPopup( product, variant )
{
    var popup = document.querySelector( ".js-autoship-atc-popup" );
    if ( popup )
    {
        var rrp           = variant.price;
        var autoshipPrice = variant.selling_plan_allocations[ 0 ].price;
        popup.querySelector( ".js-autoship-atc-popup-quantity" ).textContent = 1;
        var imageSrc = (
            (variant.featured_image?.src) || 
            (product.featured_image?.src) || 
            (product.images?.[0]) || 
            ''
        );
        popup.querySelector(".js-autoship-atc-popup-image").src = imageSrc;
        popup.querySelector( ".js-autoship-atc-popup-title" ).textContent = product.title;
        popup.querySelector( ".js-autoship-atc-popup-autoship-price" ).textContent = formatter.format( autoshipPrice / 100 );
        popup.querySelector( ".js-autoship-atc-popup-rrp" ).textContent = formatter.format( rrp / 100 );
        popup.dataset.variantId = variant.id;
        var lineKey = null;
        var cartItem = document.querySelector(
            `.cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id="${variant.id}"][data-selling-plan-id]`
        );

        if ( cartItem )
        {
            lineKey = cartItem.getAttribute("data-line-item-id");
        }
        popup.dataset.lineKey = lineKey;
        toggleAutoshipATCPopup( true );
    }
}

initAutoshipATCPopup( );